import { render, staticRenderFns } from "./MessageListItem.vue?vue&type=template&id=51665aea&scoped=true"
import script from "./MessageListItem.vue?vue&type=script&lang=js"
export * from "./MessageListItem.vue?vue&type=script&lang=js"
import style0 from "./MessageListItem.vue?vue&type=style&index=0&id=51665aea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51665aea",
  null
  
)

/* custom blocks */
import block0 from "./MessageListItem.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports